import {FC, useState} from 'react'
import {CallsContext} from '../../../@types'


export const CallsProvider: FC = ({children}) => {

  const [reloadKey, setReloadKey] = useState<number>(0)

  const triggerReload = () => setReloadKey(prevState => prevState + 1)

  return (
    <CallsContext.Provider value={{reloadKey, triggerReload}}>
      {children}
    </CallsContext.Provider>
  )
}

